import MyApp from "./app";

window.MyApp = MyApp;